<div style="min-height:400px; display: flex; align-items: center;justify-content: center;">
    <div style="text-align: center;">
        <div class="flex justify-center">
            <img src="/silone/silone_notfound.png" style="height: 100px;"/>
          </div>
        <div style="font-size: xx-large;">
            {{_common.user_notfound}}
        </div>
    </div>


</div>
